/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { image_space_picture$ref } from "./image_space_picture.graphql";
import type { FragmentReference } from "relay-runtime";
declare export opaque type cardSkin1_item$ref: FragmentReference;
declare export opaque type cardSkin1_item$fragmentType: cardSkin1_item$ref;
export type cardSkin1_item = {|
  +title: ?string,
  +rate: ?number,
  +reviewCounter: ?number,
  +urlByLang: ?string,
  +type: ?string,
  +description: ?string,
  +pictures: ?$ReadOnlyArray<?{|
    +$fragmentRefs: image_space_picture$ref
  |}>,
  +dataByCategory: ?{|
    +price: ?{|
      +amount_excl_tax: ?number
    |}
  |},
  +$refType: cardSkin1_item$ref,
|};
export type cardSkin1_item$data = cardSkin1_item;
export type cardSkin1_item$key = {
  +$data?: cardSkin1_item$data,
  +$fragmentRefs: cardSkin1_item$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "lang",
    "variableName": "lang"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lang"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "cardSkin1_item",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewCounter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "urlByLang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "count",
          "value": 1
        }
      ],
      "concreteType": "SpacePicture",
      "kind": "LinkedField",
      "name": "pictures",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "image_space_picture"
        }
      ],
      "storageKey": "pictures(count:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DataByCategory",
      "kind": "LinkedField",
      "name": "dataByCategory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount_excl_tax",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '8f8c3f70d4259727a1fb1aec7cc61b3c';

module.exports = node;
